import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const state = () => ({
    stockWatchlist: {
      watchlist: [],
      updatedAt: null
    },
    fundWatchlist: {
      watchlist: [],
      updatedAt: null
    },
    goldWatchlist: {
      watchlist: [],
      updatedAt: null
    },
    loadingWatchlist: false
})

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
